import React from "react";
import { useStyles } from "./Subheader.styles";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const Subheader = ({ children, className = "" }: Props) => {
  const classes = useStyles();

  return (
    <>
      <div className={`${classes.container} ${className}`}>{children}</div>
    </>
  );
};
